import { Tag, Tooltip, Button } from "antd";
import { UndoOutlined } from "@ant-design/icons";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import PermisosEditor from "../PermisosEditor";

// Editor de permisos a nivel USUARIO. Maneja overrides individuales que tienen
// prioridad sobre los permisos del perfil; el render lo hace <PermisosEditor>.
class PermisosUsuarioEditor extends Component {
  state = {
    permisosPerfil: [],
  };

  componentDidMount() {
    if (this.props.perfilId) this.cargarPermisosPerfil(this.props.perfilId);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.perfilId !== this.props.perfilId) {
      if (this.props.perfilId) this.cargarPermisosPerfil(this.props.perfilId);
      else this.setState({ permisosPerfil: [] });
    }
  }

  cargarPermisosPerfil = async (perfilId) => {
    await axios
      .post(
        "perfiles/datosPerfil",
        { perfilId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) return;
        const permisosPerfil = (res.data.permisos || []).map((p) => ({
          permisoId: p.permisoId.toString(),
          activado: p.activado,
          valor: p.valor ?? null,
        }));
        this.setState({ permisosPerfil });
      });
  };

  getOverride = (id) =>
    (this.props.overrides || []).find((o) => o.permisoId === id);

  getDelPerfil = (id) =>
    this.state.permisosPerfil.find((p) => p.permisoId === id);

  efectivo = (id) => {
    const ov = this.getOverride(id);
    if (ov) return { activado: ov.activado, valor: ov.valor, esOverride: true };
    const pf = this.getDelPerfil(id);
    if (pf) return { activado: pf.activado, valor: pf.valor, esOverride: false };
    return { activado: false, valor: null, esOverride: false };
  };


  aplicarToggle = (overrides, id, checked) => {
    const pf = this.getDelPerfil(id);
    if (pf && pf.activado === checked) {
      return overrides.filter((o) => o.permisoId !== id);
    }
    const i = overrides.findIndex((o) => o.permisoId === id);
    if (i === -1) {
      const valor = pf ? pf.valor ?? null : null;
      return [...overrides, { permisoId: id, activado: checked, valor }];
    }
    const next = [...overrides];
    next[i] = { ...next[i], activado: checked };
    return next;
  };

  getEstadoPermiso = (id) => {
    const e = this.efectivo(id);
    return { activado: e.activado, valor: e.valor };
  };

  // Activa/desactiva permisos en un solo onChange.
  onToggleVarios = (ids, checked) => {
    let overrides = [...(this.props.overrides || [])];
    ids.forEach((id) => {
      overrides = this.aplicarToggle(overrides, id, checked);
    });
    this.props.onChange(overrides);
  };

  onChangeValor = (id, valor) => {
    const overrides = [...(this.props.overrides || [])];
    const i = overrides.findIndex((o) => o.permisoId === id);
    const efect = this.efectivo(id);
    const base = { permisoId: id, activado: efect.activado, valor: efect.valor };
    if (i === -1) overrides.push({ ...base, valor });
    else overrides[i] = { ...overrides[i], valor };
    this.props.onChange(overrides);
  };

  revertirPermiso = (id) => {
    this.props.onChange(
      (this.props.overrides || []).filter((o) => o.permisoId !== id)
    );
  };

  renderBadge = (id) => {
    const ov = this.getOverride(id);
    if (ov) {
      return (
        <Tooltip title="Revertir al perfil">
          <Tag color="gold" style={{ marginLeft: 6 }}>
            Personalizado
            <Button
              type="link"
              size="small"
              icon={<UndoOutlined />}
              onClick={(e) => {
                e.stopPropagation();
                this.revertirPermiso(id);
              }}
              style={{ padding: "0 2px", marginLeft: 4 }}
            />
          </Tag>
        </Tooltip>
      );
    }
    return (
      <Tag color="blue" style={{ marginLeft: 6 }}>
        Del perfil
      </Tag>
    );
  };

  render() {
    if (!this.props.perfilId) {
      return (
        <p style={{ opacity: 0.7 }}>
          Selecciona un perfil para poder personalizar los permisos del usuario.
        </p>
      );
    }
    const totalOverrides = (this.props.overrides || []).length;
    const headerExtra = (
      <>
        <span style={{ marginRight: 8, opacity: 0.7 }}>
          {totalOverrides} modificación{totalOverrides === 1 ? "" : "es"}
        </span>
        {totalOverrides > 0 ? (
          <Tooltip title="Quitar todas las modificaciones y volver a los permisos del perfil">
            <Button size="small" onClick={() => this.props.onChange([])}>
              Revertir todo al perfil
            </Button>
          </Tooltip>
        ) : null}
      </>
    );
    return (
      <PermisosEditor
        headersToken={this.props.headersToken}
        tipo={this.props.tipo}
        usuarioPrincipal={this.props.usuarioPrincipal}
        getEstadoPermiso={this.getEstadoPermiso}
        onToggleVarios={this.onToggleVarios}
        onChangeValor={this.onChangeValor}
        renderBadge={this.renderBadge}
        headerExtra={headerExtra}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  tipo: state.user.tipo,
  usuarioPrincipal: state.user.usuarioPrincipal,
});

export default connect(mapStateToProps)(PermisosUsuarioEditor);
